import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { FRAGMENT_RECOMPOSE_REQUEST, FRAGMENT_SUGGEST_REQUEST } from 'src/graphql/generation';
import { getSingleProp, throwIfResultHasErrors } from 'src/lib/graphql';
import type {
  BackendProject,
  BackendProjectGenerationRequestsArgs,
  BackendQueryProjectArgs,
} from 'src/types/backend';

const QUERY = gql`
  query ProjectGenerationResults($projectId: Int!, $assetType: String, $cursor: String) {
    project(id: $projectId) {
      generationRequests(assetType: $assetType, cursor: $cursor) {
        edges {
          node {
            ... on RecomposeRequest {
              ...RecomposeRequest
            }
            ... on SuggestionRequest {
              ...SuggestionRequest
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
  ${FRAGMENT_RECOMPOSE_REQUEST}
  ${FRAGMENT_SUGGEST_REQUEST}
`;

type Variables = {
  projectId: BackendQueryProjectArgs['id'];
  assetType?: BackendProjectGenerationRequestsArgs['assetType'];
  cursor?: BackendProjectGenerationRequestsArgs['cursor'];
};
type Result = Pick<BackendProject, 'generationRequests'>;

export const queryGenerationResults = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  throwIfResultHasErrors(result);

  const data = getSingleProp<Result>(result.data);
  return data?.generationRequests;
};
